import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const EditorSideBySide = ({ height = 97, width = 174, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 174 97" {...props}>
    <path
      fill="#FFFFFF"
      d="M9,1h156c4.4,0,8,3.6,8,8v79c0,4.4-3.6,8-8,8H9c-4.4,0-8-3.6-8-8V9C1,4.6,4.6,1,9,1z"
    />
    <path
      fill="none"
      stroke="#F5F4F4"
      d="M9,0.5h156c4.7,0,8.5,3.8,8.5,8.5v79c0,4.7-3.8,8.5-8.5,8.5H9c-4.7,0-8.5-3.8-8.5-8.5V9
      C0.5,4.3,4.3,0.5,9,0.5z"
    />
    <path fill="#F5F4F4" d="M1,12v76c0,4.4,3.6,8,8,8h156c4.4,0,8-3.6,8-8V12H1z" />
    <path
      fill="#FFFFFF"
      d="M99,19h46c2.2,0,4,1.8,4,4v62c0,2.2-1.8,4-4,4H99c-2.2,0-4-1.8-4-4V23C95,20.8,96.8,19,99,19z"
    />
    <path
      fill="#FFFFFF"
      stroke="#F5F4F4"
      d="M107,47.5h30c1.9,0,3.5,1.6,3.5,3.5v26c0,1.9-1.6,3.5-3.5,3.5h-30c-1.9,0-3.5-1.6-3.5-3.5
      V51C103.5,49.1,105.1,47.5,107,47.5z"
    />
    <path fill="#E6FBFF" d="M108,52h28v24h-28V52z" />
    <path
      fill="#59C1A7"
      d="M113.9,70l4.1-5c0.6-0.8,1.7-0.9,2.5-0.3c0.1,0,0.1,0.1,0.2,0.1l1.2,1.1l3.9-4.8c0.6-0.8,1.7-0.9,2.5-0.3
      c0.1,0.1,0.2,0.2,0.4,0.3L135,69"
    />
    <rect x="108" y="69" fill="#34C3F2" width="28" height="7" />
    <path
      fill="#F2CA1B"
      d="M111,57.5c0,1.3,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5s-1.2-2.5-2.5-2.5S111,56.1,111,57.5z"
    />
    <line
      fill="none"
      stroke="#CCC8CA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="103.8"
      y1="41.2"
      x2="123.2"
      y2="41.2"
    />
    <line
      fill="none"
      stroke="#CCC8CA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="103.8"
      y1="36.2"
      x2="134.2"
      y2="36.2"
    />
    <line
      fill="none"
      stroke="#CCC8CA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="103.8"
      y1="31.2"
      x2="129.2"
      y2="31.2"
    />
    <line
      fill="none"
      stroke="#CCC8CA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="103.8"
      y1="26.2"
      x2="139.2"
      y2="26.2"
    />
    <path
      fill="#787174"
      d="M38,19h46c2.2,0,4,1.8,4,4v62c0,2.2-1.8,4-4,4H38c-2.2,0-4-1.8-4-4V23C34,20.8,35.8,19,38,19z"
    />
    <path
      fill="#FBC3CB"
      d="M47,28h15c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1H47c-0.6,0-1-0.4-1-1l0,0C46,28.4,46.4,28,47,28z"
    />
    <path
      fill="#FBC3CB"
      d="M47,44.9h15c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1H47c-0.6,0-1-0.4-1-1l0,0C46,45.4,46.4,44.9,47,44.9z"
    />
    <path
      fill="#B8B1B4"
      d="M47,50.5h33c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1H47c-0.6,0-1-0.4-1-1l0,0C46,51,46.4,50.5,47,50.5z"
    />
    <path
      fill="#B8B1B4"
      d="M47,56.2h33c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1H47c-0.6,0-1-0.4-1-1l0,0C46,56.6,46.4,56.2,47,56.2z"
    />
    <path
      fill="#C2F0FC"
      d="M65,28h8c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1h-8c-0.6,0-1-0.4-1-1l0,0C64,28.4,64.4,28,65,28z"
    />
    <path
      fill="#C2F0FC"
      d="M51,33.6h20c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1H51c-0.6,0-1-0.4-1-1l0,0C50,34.1,50.4,33.6,51,33.6z"
    />
    <path
      fill="#FAECAD"
      d="M74,33.6h6c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1h-6c-0.6,0-1-0.4-1-1l0,0C73,34.1,73.4,33.6,74,33.6z"
    />
    <path
      fill="#CAF3E7"
      d="M51,39.3h29c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1H51c-0.6,0-1-0.4-1-1l0,0C50,39.7,50.4,39.3,51,39.3z"
    />
    <path
      fill="#FBC3CB"
      d="M47,62h15c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1H47c-0.6,0-1-0.4-1-1l0,0C46,62.4,46.4,62,47,62z"
    />
    <path
      fill="#FBC3CB"
      d="M47,78.9h15c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1H47c-0.6,0-1-0.4-1-1l0,0C46,79.4,46.4,78.9,47,78.9z"
    />
    <path
      fill="#C2F0FC"
      d="M51,68h10c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1H51c-0.6,0-1-0.4-1-1l0,0C50,68.4,50.4,68,51,68z"
    />
    <path
      fill="#FAECAD"
      d="M64,68h7c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1h-7c-0.6,0-1-0.4-1-1l0,0C63,68.4,63.4,68,64,68z"
    />
    <path
      fill="#CAF3E7"
      d="M74,68h6c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1h-6c-0.6,0-1-0.4-1-1l0,0C73,68.4,73.4,68,74,68z"
    />
    <path
      fill="#CAF3E7"
      d="M51,73h21c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1H51c-0.6,0-1-0.4-1-1l0,0C50,73.4,50.4,73,51,73z"
    />
    <path
      fill="#FFF8D9"
      d="M75,73h5c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1h-5c-0.6,0-1-0.4-1-1l0,0C74,73.4,74.4,73,75,73z"
    />
    <path
      opacity="0.34"
      fill="#3D3A3B"
      enableBackground="new    "
      d="M34,23c0-2.2,1.8-4,4-4h3v70h-3c-2.2,0-4-1.8-4-4V23z"
    />
    <line
      fill="none"
      stroke="#B8B1B4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="52"
      y1="7"
      x2="57"
      y2="7"
    />
    <line
      fill="none"
      stroke="#B8B1B4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="38"
      y1="7"
      x2="43"
      y2="7"
    />
    <line
      fill="none"
      stroke="#B8B1B4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="24"
      y1="7"
      x2="29"
      y2="7"
    />
    <line
      fill="none"
      stroke="#B8B1B4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="10"
      y1="7"
      x2="15"
      y2="7"
    />
  </SvgIcon>
);
